export const generateZillowLink = ({ address, city, state, zip } = {}) => {
  if (!address || !city || !state || !zip) {
    return '';
  }
  return `https://www.zillow.com/homes/${address.replaceAll(' ', '-')}-${city.replaceAll(
    ' ',
    '-'
  )},-${state}-${zip}_rb`;
};

function joinIgnoringFalsy(strings, separator = ' ') {
  return strings.filter((str) => !!str).join(separator);
}

export const generateGoogleMapsLink = ({ address, address2, city, state, zip } = {}) => {
  if (!address && !city && !state && !zip) {
    return '';
  }
  const searchableAddress = joinIgnoringFalsy([address, address2, city, state, zip], ' ');
  return `https://www.google.com/maps/place/${searchableAddress}`;
};
